import styled from 'styled-components';
import { mainCouch } from './mainCouch';

export const InternalPage = styled.div`
	${mainCouch};
	margin-top: 150px;
`;
